import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/client/book/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/client/book/practitioner' });
  },
});
